import React, { useRef, useContext } from 'react';
import { QuickLinksContext } from './QuickLinksContext';
import { useDragHandler } from '../hooks/useDragHandler';
import LinkPill from './LinkPill';
import LinksSkeleton from './LinksSkeleton';

const LinksContent = () => {
  const { links, loading, label } = useContext(QuickLinksContext);
  const linksRef = useRef();
  const containerRef = useRef();

  useDragHandler(containerRef, linksRef);

  if (loading) return <LinksSkeleton />;

  return (
    <div className="sui-flex sui-flex-grow sui-items-center sui-gap-4 sui-overflow-hidden">
      {label && (
        <span
          className="sui-flex sui-h-8 sui-items-center sui-font-bold sui-text-base
            sui-whitespace-nowrap sui-pl-2"
          data-component="LinksLabel"
        >
          <span className="sui-hidden md:sui-inline">{label.desktop}</span>
          <span className="md:sui-hidden">{label.mobile}</span>
        </span>
      )}
      <div
        className="sui-flex sui-flex-grow sui-overflow-hidden sui-relative sui-h-8 sui-touch-none"
        ref={containerRef}
        data-component="LinksContent"
      >
        <div
          role="navigation"
          ref={linksRef}
          className="sui-flex sui-h-8 sui-px-2 sui-gap-4 sui-items-center sui-absolute sui-select-none"
        >
          {links?.map((link, index) => {
            return (
              <LinkPill
                key={`quick-link-${link.label}-${index}`}
                link={link}
                index={index}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

LinksContent.propTypes = {
};

export default LinksContent;
